import React from 'react';

import {AtomicBlockUtils, EditorState, SelectionState} from 'draft-js';
import AttachmentComponent from './attachment-component/attachment-component';

import { ENTITY_TYPE } from "../../api/constants";
import removeBlock from "../block-dnd/modifiers/remove-block";
export const Attachment = AttachmentComponent;

// const debug = "addAttachment"
const debug = false

export const addAttachment = (editorState, attachment) => {
    const contentState = editorState.getCurrentContent();


    let aspectRatio;

    if (attachment.previewAvailable) {
        // aspectRatio = data.aspectRatio ? data.aspectRatio : 102/110;
        aspectRatio = 102/110;
    }

    debug && console.log(debug, "addAttachment in rich editor", attachment)


    // data = file object from dropzone....

    // I guess this is what we store in Rich Editor ?

    // NEW
    const extraData = {
        aspectRatio     : aspectRatio,
        fileId          : attachment.fileId,
        noPreview       : !attachment.previewAvailable // passed to resizable plugin
    }

    debug && console.log("   extraData=", extraData)

    const contentStateWithEntity = contentState.createEntity(
        ENTITY_TYPE.ATTACHMENT,
        'IMMUTABLE',
        _.assign({}, extraData)
    );

    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    const newState1 = AtomicBlockUtils.insertAtomicBlock(
        editorState,
        entityKey,
        ' '
    );

    return EditorState.push(editorState, newState1.getCurrentContent(), 'insert-characters');
}

export default function createAttachmentPlugin(config = {}, attachmentsCollection=null) {

    const store = {
        getEditorState: undefined,
        setEditorState: undefined,
    };

    let Attachment = AttachmentComponent;
    if (config.decorator) Attachment = config.decorator(Attachment);

    const onRemove = (blockKey) => {
        const editorState = store.getEditorState();
        const contentState = editorState.getCurrentContent();
        const contentStateAfterRemove = removeBlock(
            contentState,
            blockKey
        );

        // force to new selection
        const newSelection = new SelectionState({
            anchorKey: blockKey,
            anchorOffset: 0,
            focusKey: blockKey,
            focusOffset: 0,
        });
        const newState = EditorState.push(
            editorState,
            contentStateAfterRemove,
            'remove-block'
        );

        store.setEditorState(EditorState.forceSelection(newState, newSelection));
    }

    return {
        initialize: ({ getEditorState, setEditorState }) => {
            store.getEditorState = getEditorState;
            store.setEditorState = setEditorState;
        },
        blockRendererFn: (block, { getEditorState }) => {
            let res = null;
            if (block.getType() === 'atomic') {
                const contentState = getEditorState().getCurrentContent();
                const entity = block.getEntityAt(0);
                if (!entity) return null;
                const type = contentState.getEntity(entity).getType();

                if (type === ENTITY_TYPE.ATTACHMENT || type === 'attachment') {
                    res = {
                        component: Attachment,
                        editable: false,
                        props: {
                            onRemove                : onRemove,
                            attachmentsCollection   : attachmentsCollection,
                        }
                    };
                }
            }

            return res;
        }
    };
};